import useResizeListener from '../../hooks/useResizeListener';

function ResizeWrapper({ children, onResize }) {
  useResizeListener(onResize);

  return children;
}

export default ResizeWrapper;
